import React from "react";
import Spinner from "./Spinner";

/**
 * A component that handles loading states and conditional rendering based on authorization.
 *
 * @param {Object} props
 * @param {boolean} props.isLoading - Whether data is still loading
 * @param {boolean} props.isAuthorized - Whether the user is authorized to view the content
 * @param {React.ReactNode} props.authorizedContent - The content to show when authorized
 * @param {React.ReactNode} props.unauthorizedContent - The content to show when not authorized
 * @param {string} props.unauthorizedTitle - The title to show when not authorized (optional)
 * @param {string} props.unauthorizedMessage - The message to show when not authorized (optional)
 */
const AuthorizedContent = ({
  isLoading,
  isAuthorized,
  authorizedContent,
  unauthorizedContent,
  unauthorizedTitle = "Kun administratorer har tilgang til denne siden",
  unauthorizedMessage = "Du har ikke tilstrekkelige rettigheter til å administrere denne siden."
}) => {
  // Show spinner when loading
  if (isLoading) {
    return <Spinner show={true} />;
  }

  // Show authorized content when authorized
  if (isAuthorized) {
    return authorizedContent;
  }

  // Show unauthorized content or default message
  return (
    unauthorizedContent || (
      <div style={{ padding: "5rem", textAlign: "center" }}>
        <h2>{unauthorizedTitle}</h2>
        <p>{unauthorizedMessage}</p>
      </div>
    )
  );
};

export default AuthorizedContent;
